import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { HttpClient, HttpHeaders } from "@angular/common/http";


import { EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class VaService {

  agents: Array<any> = [];
  activeAgent: any = null;
  agentAdditionalInfo: any = null;
  public params;
  currentAgentId: any = null;
  activeAgentChanged:EventEmitter<String> = new EventEmitter();
  agentChangedEvent: EventEmitter<String> = new EventEmitter();
  flowChangedEvent: EventEmitter<Number> = new EventEmitter();
  projectDeleteEvent: EventEmitter<String> = new EventEmitter();
  breadCrumbChangeEvent: EventEmitter<Number> = new EventEmitter();
  shareConfigList: EventEmitter<Object> = new EventEmitter();
  currentUserRole: any;
  userRoleChanged: EventEmitter<Object> = new EventEmitter();
  menuChanged: EventEmitter<Object> = new EventEmitter();
  roleChanged: EventEmitter<Object> = new EventEmitter();
  addQuestionEvent: EventEmitter<boolean> = new EventEmitter();
  userQueryEditEvent: EventEmitter<Object> = new EventEmitter();
  configDeleteEvent: EventEmitter<Object> = new EventEmitter();
  headingChangedEvent : EventEmitter<Object> = new EventEmitter();
  InstructorDashboardupdate: EventEmitter<Object> = new EventEmitter();
  showSubMenuEvent: EventEmitter<any> = new EventEmitter();
  subItemClickEvent: EventEmitter<any> = new EventEmitter();
  contentTextUpdated: EventEmitter<any> = new EventEmitter();
  updateQuestions:EventEmitter<Object> = new EventEmitter();
  updateMappingContent:EventEmitter<Object> = new EventEmitter();
  activeAgentInService: any;
  public minimizeAdvanceTestWidget: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public closeVaPreview: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private releaseTaskId: string;

  constructor(private http: HttpClient) {
  }

  setActiveAgent(agentId) {
    
    this.activeAgent = this.agents.filter((agent) => {
      return agent['_id']['$oid'] == agentId;
    })[0];
    this.activeAgentChanged.emit(this.activeAgent);
  }

  isVaLaunched(): boolean {
    let result = false;
    if (environment.ALLOW_TESTVA_DEPLOYMENT) {
      if (this.activeAgent.container_details_test && this.activeAgent.container_details_test.status == 1) {
        result = true;
      }
    } else {
      if (this.activeAgent.container_details && this.activeAgent.container_details.status == 1) {
        result = true;
      }
    }
    return result;
  }

  getAgents(): Observable<Array<Object>> {
    return this.http.get(environment.va_service_api + 'agents/').pipe(
      map((response: Array<Object>) => {
        this.agents = response;
        return response;
      }),
      catchError((err: any) => {
        console.log(err);
        throw err;
      })
    );
  }

  getFilteredAgents(params) {
    return this.http.get(environment.va_service_api + "agents/", { params: params })
  }

  getArchievedAgents() {
    return this.http.get(environment.va_service_api + "agents/archive")
  }

  getTimezones() {
    return this.http.get(environment.va_service_api + "agents/timezone")
  }

  getUserRole(agentId) {
    return this.http.get(environment.va_service_api + "agents/get_user_role/" + agentId).pipe(
      map((response: Array<Object>) => {
        this.currentUserRole = response['user']['role'];
        this.currentAgentId = agentId;
        if (this.activeAgent && !this.activeAgent.date_format){
          this.activeAgent["date_format"] = "MM-dd-yyyy";
        }
        this.userRoleChanged.emit(this.currentUserRole);
        // this.menuChanged.emit(this.currentUserRole);
        return response;
      })
    );
  }

  getTemplates(agentId) {
    return this.http.get(environment.va_service_api + "agents/get_templates/" + agentId)
  }

  newAgent(details) {
    return this.http.post(environment.va_service_api + "agents/", details)
  }

  newAgentFromExport(agent_zip, details, userName) {

    const formdata: FormData = new FormData();
    formdata.append('agent_zip', agent_zip);
    formdata.append('title', details["title"]);
    formdata.append('description', details["description"]);
    formdata.append('client_name', details["client_name"]);
    formdata.append('user_name', userName);


    return this.http.post(environment.va_launcher_api + "va_backup/restore", formdata, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data')
    }).pipe(
      map((response: any) => {
        return response;
      })
    );
  }


  changeAgent(agentInfo) {
    this.agentChangedEvent.emit(agentInfo);
    this.activeAgentChanged.emit(agentInfo);
    this.activeAgent = agentInfo;
  }

  moveAgentToTrash(agentId) {
    return this.http.delete(environment.va_service_api + "agents/" + agentId + "/archive", agentId)
      .pipe(
        map((response: any) => {
          this.agents = this.agents.filter((agent) => {
            return agent['_id']['$oid'] != agentId;
          });
          return response;
        })
      );
  }
  restoreAgentFromTrash(agentId) {
    return this.http.put(environment.va_service_api + "agents/" + agentId + "/restore", {"agent_id": agentId})
      .pipe(
        map((response: any) => {
          this.agents = this.agents.filter((agent) => {
            return agent['_id']['$oid'] != agentId;
          });
          return response;
        })
      );
  }

  deleteAgent(agentId) {
    return this.http.delete(environment.va_service_api + "agents/" + agentId)
      .pipe(
        map((response: any) => {
          this.agents = this.agents.filter((agent) => {
            return agent['_id']['$oid'] != agentId;
          });
          return response;
        })
      );
  }

  getAgent(agentId) {
    this.activeAgentInService = agentId;

    //this.getUserRole(agentId).subscribe();
    return this.http.get(environment.va_service_api + "agents/" + agentId)
      .pipe(
        map((response: Response) => {
          if (!response['date_format']){
            response["date_format"] = "MM-dd-yyyy";
          }
          return response;
        })
      );
  }

  getAgentAdditionalInfo(agentId) {
    return this.http.get(environment.va_service_api + "agents/additional_details/" + agentId)
      .pipe(
        map((response: Response) => {
          return response;
        })
      );
  }


  shareAgent(agentId, details) {
    return this.http.post(environment.va_service_api + "agents/share_agent/" + agentId, details)
  }

  listSharedUsers(agentId, role = null) {
    let query = "";
    if (role != null || role != undefined) {
      query = "?role=" + role;
    }
    return this.http.get(environment.va_service_api + "agents/shared_users/" + agentId + query)
  }

  removeSharedUsers(agentId, details) {
    this.params = {
      "email": details,
    };

    return this.http.post(environment.va_service_api + "agents/remove_shared_user/" + agentId, this.params)
  }

  updateSharedUsers(agentId, details) {
    return this.http.post(environment.va_service_api + "agents/update_shared_user/" + agentId, details)
  }

  /*send pinned project details*/
  pinProject(agentId, param) {
    return this.http.post(environment.va_service_api + "agents/pin/" + agentId, param)
  }
  editAgent(agentId, data) {
    this.params = data;
    return this.http.put(environment.va_service_api + "agents/" + agentId, this.params)
      .pipe(
        map((response: Response) => {
  
          let agents = this.agents.filter((agent) => {
            return agent._id.$oid == agentId;
          });
          if (agents.length){
  
            let editedAgent = agents[0];
            editedAgent.title = response["agent_info"].title;
            editedAgent.description = response["agent_info"].description;
  
          }


          return response;
        })
      );
  }

  cloneVA(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/va_clone", params)
  }

  backupVA(id) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/va_backup", {})
  }

  restoreVA(id, params) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/va_restore", params)
  }

  downloadVA(id, token) {
    return this.http.post(environment.va_launcher_api + "mas_launcher/" + id + "/va_download/" + token, {})
  }

  getAgentConfig(agent_id) {
    return this.http.get(environment.va_service_api + "mas_settings/load_configs/" + agent_id)
  }

  putAgentConfig(agent_id, data) {
    return this.http.put(environment.va_service_api + "agents/" + agent_id + "/config", data)
  }

  searchAgentConfig(query) {
    return this.http.get(environment.va_service_api + "mas_settings/search?query=" + query)
  }

  saveAgentConfig(agent_id, data) {
    return this.http.post(environment.va_service_api + "mas_settings/save/" + agent_id, data)
  }



  // Va Auth Token

  enableVaToken(agent_id, data) {
    return this.http.post(environment.va_service_api + "agents/" + 'enable_va_token/' + agent_id, data)
  }

  getVaToken(agent_id) {
    return this.http.get(environment.va_service_api + "agents/" + 'get_auth_token/' + agent_id)
  }

  setVaToken(agent_id, data) {
    return this.http.post(environment.va_service_api + "agents/" + 'set_auth_token/' + agent_id, data)
  }

  generateVaToken(agent_id) {
    return this.http.get(environment.va_service_api + "agents/" + 'generate_auth_token/' + agent_id)
  }






  addUserAuthentication(agent_id, details) {
    return this.http.put(environment.va_service_api + 'authentication/custom/' + agent_id, details)
  }


  updateUserAuthentication(agent_id, details) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agent_id, details)
  }

  deleteUserAuthentication(agent_id, row_id) {
    return this.http.delete(environment.va_service_api + 'authentication/custom/' + agent_id + "/" + row_id)
  }
  resetUserAuthentication(agent_id, row_id) {

    return this.http.get(environment.va_service_api + 'authentication/custom/' + agent_id + "/" + row_id + "/reset")
  }

  getUserAuthentication(agent_id, region) {
    return this.http.get(environment.va_service_api + 'authentication/custom/' + agent_id + "/" + region)
  }

  getVAAuthentication(agent_id, region) {
    return this.http.get(environment.va_service_api + 'authentication/custom/' + agent_id + "/status/" + region)
  }

  
  getVaJWT(agent_id) {
    return this.http.get(environment.va_service_api + 'authentication/custom/' + agent_id + "/get_va_jwt")
  }

  refeshVaJWT(agent_id) {
    return this.http.get(environment.va_service_api + 'authentication/custom/' + agent_id + "/refresh_jwt")
  }

  updateVAAuthentication(agent_id, details) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agent_id + "/enable/" + details.region, details)
  }


  resetVApassword(agent_id, details, token) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agent_id + '/set_password/' + token, details)
  }

  validateToken(agent_id, details, token) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agent_id + '/validate_token/' + token, details)
  }

  addConfiguration(agent_id, configInfo) {
    return this.http.put(environment.va_service_api + 'authentication/config/' + agent_id, configInfo)
  }

  getConfiguration(agent_id) {
    // listing all congig left side
    return this.http.get(environment.va_service_api + 'authentication/config/' + agent_id)
  }
  deleteConfiguration(agent_id, selected_config_id) {
    // delete congig left side
    return this.http.delete(environment.va_service_api + 'authentication/config/' + agent_id + '/' + selected_config_id)
  }

  updateConfiguration(agent_id, selected_config_id, configInfo) {
    // save button
    return this.http.post(environment.va_service_api + 'authentication/config/' + agent_id + '/' + selected_config_id, configInfo)
  }

  getConfiguration_info(agent_id, selected_config_id) {
    // when left side config is clicked
    return this.http.get(environment.va_service_api + 'authentication/config/' + agent_id + '/' + selected_config_id)
  }


  //  Instructor Dashboard https://ciradev.cognicor.com/project_service/retraining_module/5be921ea8b0fcb000c175bc5/instructor_data


  // get Instructor 
  getInstructor(agentId) {
    return this.http.get(environment.va_service_api + 'retraining_module/' + agentId + "/instructor_data")
  }




  // get Questions
  getQuestionsList(agentId, optionalParams) {
    return this.http.get(environment.va_service_api + 'retraining_module/' + agentId + '/questions', { params: optionalParams })
  }



  declineQuestion(agentId, qustnId) {
    return this.http.delete(environment.va_service_api + "retraining_module/" + agentId + "/questions/" + qustnId + "/decline")
  }





  getSimilarQuestionsList(agentId, params) {

    return this.http.post(environment.va_service_api + 'retraining_module/' + agentId + '/view_similar_questions', params)
  }

  getSimilarQuestionDetails(agentId, annotated_id, show_similar = null) {
    let query = "";
    if (show_similar != null && show_similar != undefined) {
      query = "?show_similar=" + show_similar;
    }
    return this.http.get(environment.va_service_api + 'retraining_dashboard/' + agentId + '/answers/' + annotated_id + query)
  }

  chooseThisAnswer(agentId, answer_id, params) {
    return this.http.post(environment.va_service_api + 'retraining_module/' + agentId + '/' + answer_id + '/qa', params)
  }

  saveQuestion(agentId, params) {
    return this.http.post(environment.va_service_api + 'retraining_module/' + agentId + '/create_qa', params)
  }

  updateQuestion(agentId, questionId, params) {
    return this.http.put(environment.va_service_api + 'retraining_module/' + agentId + '/' + questionId + '/qa', params)
  }

  getAllEvents() {
    return this.http.get(environment.va_service_api + 'ui-library/get-all-event-lists')
  }

  sendFile(file_,va_region,agent_id){

    const formData: FormData = new FormData();
    formData.append('csv_file', file_, file_.name);
    formData.append('region', va_region);
    // debugger
    return this.http.post(environment.va_service_api+ 'authentication/custom/' + agent_id +'/custom_template', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })

  }

  getAllPackages(searchQuery, domain, installOption) {
    return this.http.get(environment.package_library_service + '/get_packages?search=' + searchQuery + "&domain=" + domain + "&install_options=" + installOption)
  }
  getInstalledPackages(agent_id) {
    return this.http.get(environment.va_service_api + 'package_library/'+agent_id+'/get_installed_packages')
  }

  installPackage(params, agent_id) {
    return this.http.post(environment.ontology_service_api + agent_id + '/install_package', params).pipe(map((response: Response) => {
      return response;
    },
      (err: Response) => {
        console.log(err);
        return err;
      })
    )
  }

  searchTour(query) {
    return this.http.get(environment.va_service_api + "tour_guide/search?query=" + query)
  }

  getTour(agent_id) {
    return this.http.get(environment.va_service_api + "tour_guide/get_tour/" + agent_id)
  }

  checkMissingEntities(agent_id, release_id) {
    return this.http.get(environment.va_service_api +  agent_id + '/profile_library/check_missing_entities?release_id=' + release_id)
  }

  importMissingEntities(agent_id, release_id, param) {
    return this.http.post(environment.va_service_api +  agent_id + '/profile_library/import_entities_to_release?release_id=' + release_id, param)
  }

  getSettings(agentId) {
    return this.http.get(environment.va_service_api + 'ui-library/get-settings/' + agentId)
  }

  //For closing Conversational feedback
  closeFeedback(){
    const event = new CustomEvent('cognicor.closeCFB', {
      detail : {
        closeCFB : true
      }
    });
    window.dispatchEvent(event);
	}

  saveAuthSettings(agentId, params) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agentId + '/dashboard_password_policy', params)
  }

  unlockUserAuthentication(agent_id, params) {
    return this.http.post(environment.va_service_api + 'authentication/custom/' + agent_id + '/unlock_user', params)
  }

  fetchAuthSettings(agentId) {
    return this.http.get(environment.va_service_api + 'authentication/custom/' + agentId + '/fetch_dashboard_password_policy')
  }

  getLibraryProjects(params) {
    return this.http.get(environment.va_service_api + "agents/library_project", { params: params })
  }

  getAuditLogs(agentId, params) {
    return this.http.post(environment.va_service_api + "agents/audit_log/" + agentId, params)
  }

  downloadLogs(agentId, params) {
    return this.http.post(environment.va_service_api + "agents/download_audit_log/" + agentId, params)
  }

  getLogRetainPeriod(agentId) {
    return this.http.get(environment.va_service_api + "agents/get_audit_retention_period/" + agentId)
  }

  saveLogRetainPeriod(agentId, params) {
    return this.http.post(environment.va_service_api + "agents/save_audit_retention_period/" + agentId, params) 
  }
  
  setTaskId(id: string): void {
    this.releaseTaskId = id;
  }

  getTaskId(): string {
    return this.releaseTaskId;
  }
}